import React, { useState, useEffect, useMemo, useRef, useContext, memo } from "react";
import AppContext from "../../../../context/Context";
import DnDTable from "../position-comp/DnDTable";

const ListPositions = ({
updateBasket,
setupdateBasket,
positionRef,
  loder,
  position,
  isDragBasket,
  setisDragBasket,
  sockSource,
  isFirstTime,
  loadPage,
  tabs,
  buySellClick,
  inputValues,
  socketupdated,
  info,
  width,
  height,
  size,
  columns,
  getPNL,
  basketSLTP,
  isClosedPosition,
  totalPNL,
  searchText,
  checkedId,
  setcheckedId,
  subGroupingMode,
  setSubGroupingMode,
  groupingMode,
  setGroupingMode,
  basketMargins
}) => {

  return (
    <DnDTable
      loder={loder}
      positionRef={positionRef}
      position={position}
      isDragBasket={isDragBasket}
      setisDragBasket={setisDragBasket}
      sockSource={sockSource}
      isFirstTime={isFirstTime}
      loadPage={loadPage}
      tabs={tabs}
      buySellClick={buySellClick}
      inputValues={inputValues}
      getPNL={getPNL}
      socketupdated={socketupdated}
      info={info}
      width={width}
      height={height}
      size={size}
      columns={columns}
      updateBasket={updateBasket} 
      setupdateBasket={setupdateBasket} 
      basketSLTP={basketSLTP}
      isClosedPosition={isClosedPosition}
      totalPNL={totalPNL}
      searchText={searchText}
      checkedId={checkedId}
      setcheckedId={setcheckedId}
      groupingMode={groupingMode}
      setGroupingMode={setGroupingMode}
      subGroupingMode={subGroupingMode}
      setSubGroupingMode={setSubGroupingMode}
      basketMargins={basketMargins}
    />

  );
};

export default memo(ListPositions);
